export const availableShopifyVariants = product =>
  (Array.isArray(product?.variants) ? product.variants : []).filter(
    variant => variant.available_for_sale === true
  );

export const shopifyVariantLabel = variant => {
  const selectedOptions = Array.isArray(variant?.selected_options)
    ? variant.selected_options
    : [];
  const labels = selectedOptions
    .filter(
      option =>
        option.name &&
        option.value &&
        option.value.toLowerCase() !== 'default title'
    )
    .map(option => option.name + ': ' + option.value);
  return (
    labels.join(' · ') ||
    (variant?.title === 'Default Title' ? '' : variant?.title || '')
  );
};

export const shopifyVariantQuantity = (items, variantId) =>
  Number(items.find(item => item.variant_id === variantId)?.quantity || 0);

export const updateShopifyCartVariantQuantity = (
  items,
  product,
  variant,
  delta,
  maxQuantity = 20
) => {
  if (!variant?.id || !Number.isFinite(delta) || delta === 0) return items;

  const current = items.find(item => item.variant_id === variant.id);
  if (current) {
    const currentQuantity = Number(current.quantity) || 0;
    const quantity = Math.max(
      0,
      Math.min(maxQuantity, currentQuantity + delta)
    );
    if (quantity === currentQuantity) return items;
    if (quantity === 0) {
      return items.filter(item => item.variant_id !== variant.id);
    }
    return items.map(item =>
      item.variant_id === variant.id ? { ...item, quantity } : item
    );
  }

  if (delta < 0) return items;
  return [
    ...items,
    {
      product_id: product.id,
      product_title: product.title,
      variant_id: variant.id,
      variant_title: variant.title,
      quantity: Math.min(maxQuantity, delta),
      price: variant.price,
      currency_code: variant.currency_code,
    },
  ];
};
